import React from "react";
import peliculas from "../db.json";
import { Link } from "react-router-dom";
import estilo from "../styles/Ranking.module.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

function Ranking() {
  //estrenos
  const estrenos = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .filter((e) => e.calificacion >= 7);
  // console.log(estrenos);
  return (
    <Swiper
      slidesPerView={4}
      spaceBetween={15}
      centeredSlides={false}
      loop={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      breakpoints={{
        0: {
          slidesPerView: 3,
        },
        578: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 5,
        },
        960: {
          slidesPerView: 6,
        },
        1200: {
          slidesPerView: 8,
        },
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      {estrenos.map((e, i) => (
        <SwiperSlide key={i}>
          <Link
            to={e.tipo === "pelicula" ? "/pelicula/" + e.id : "/serie/" + e.id}
          >
            <div className={estilo.tarjetas}>
              <img src={e.portada} alt={e.titulo} className={estilo.slider} />
              <span>Calificación: {e.calificacion}</span>
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Ranking;
